import React, { useMemo } from 'react'

import { useAtomValue } from 'jotai'
import { useSelectedTrial } from 'src/features/auth/context'

import { VisibilityBulkSetModalComponent } from './visibility-bulk-set-modal-component'
import { templateDetailAtom } from '../../atom'
import { TrialHospitalsByUid } from '../../trial-hospitals-by-uid'
import { useOnChangeMultiselect } from '../use-on-change-multiselect'
import { useUpdateSmallItemVisibility } from '../use-update-small-item-visibility'

type Props = {
  onClose: () => void
}

export const VisibilityBulkSetModalContainer: React.FC<Props> = props => {
  const { onClose } = props

  const template = useAtomValue(templateDetailAtom)
  const { selectedTrial } = useSelectedTrial()
  const trialHospitalsByUid = useMemo<TrialHospitalsByUid>(
    () => Object.fromEntries(selectedTrial.trialHospitals.map(h => [h.uid, h])),
    [selectedTrial.trialHospitals],
  )
  const { request, requesting, errorMessage } = useUpdateSmallItemVisibility()

  const {
    values: selectedTrialHospitalUids,
    handlers: { onChangeMultiselect: onChangeTrialHospitals },
  } = useOnChangeMultiselect([])

  const {
    values: selectedSmallItemUids,
    handlers: { onChangeMultiselect: onChangeSmallItems },
  } = useOnChangeMultiselect([])

  const onSubmit = () => {
    const submit = async () => {
      const { originalTemplate } = template
      if (!originalTemplate) return

      try {
        await request({
          trialUid: originalTemplate.trialUid,
          templateUid: originalTemplate.uid,
          smallItemUids: selectedSmallItemUids,
          trialHospitalUids: selectedTrialHospitalUids,
        })

        onClose()
      } catch (error) {
        console.error('update smallItemVisibility Error', error)
      }
    }

    submit()
  }

  return (
    <VisibilityBulkSetModalComponent
      mediumItems={template.mediumItems}
      trialHospitalsByUid={trialHospitalsByUid}
      selectedSmallItemUids={selectedSmallItemUids}
      selectedTrialHospitalUids={selectedTrialHospitalUids}
      requesting={requesting}
      handlers={{
        onChangeSmallItems: onChangeSmallItems,
        onChangeTrialHospitals: onChangeTrialHospitals,
        onClose: onClose,
        onSubmit: onSubmit,
      }}
      errorMessage={errorMessage}
    ></VisibilityBulkSetModalComponent>
  )
}
